import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../apis/index";

const initialState = {
  status: "idle",
  error: null,
  message: null,
  careersData: null,
  isActive: false,
};

export const getCareers = createAsyncThunk(
  "careers/getCareers",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(`page/career`, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const careersSlice = createSlice({
  name: "careers",
  initialState,
  reducers: {},
  extraReducers: {
    [getCareers.pending]: (state, action) => {
      state.status = "loading";
      state.message = null;
    },
    [getCareers.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.careersData = action.payload?.data;
      state.isActive = true;

    },
    [getCareers.rejected]: (state, action) => {
      state.status = "failed";
    },
  },
});

export default careersSlice.reducer;
